import { I18n } from "@assets/strings";
import { useObservable } from "micro-observables";
import React, { useMemo } from "react";
import styled from "styled-components";
import { AttachmentSection } from "@domain/lms/article/article";
import { getAssetById } from "@domain/lms/article/utils";
import { SimpleTextInput } from "@ui/components/inputs/simpleTextInput";
import { gap } from "@ui/styles/utils";
import { useEditorController } from "@ui/pages/lms/article/articleEditorPage/articleEditorController/editorControllerContext";

interface AttachmentSectionEditorProps extends React.HTMLAttributes<HTMLDivElement> {
	section: AttachmentSection;
}
export const AttachmentSectionEditor: React.FC<AttachmentSectionEditorProps> = ({ section, ...htmlProps }) => {
	const articleController = useEditorController();
	const attachmentController = useMemo(() => articleController.attachmentSectionController(section), []);
	const observableArticle = useObservable(articleController.article);
	const asset = getAssetById(observableArticle.content, section.assetId);

	if (!asset) {
		return null;
	}

	return (
		<Container {...htmlProps}>
			<SimpleTextInput
				renderBefore={() => <Extension>{asset.mimeType.split("/")[1]}</Extension>}
				placeholder={I18n.t("article.editor.section.attachment.placeholder")}
				value={section.title}
				onChange={(v) => attachmentController.setTitle(v)}
			/>
		</Container>
	);
};

const Container = styled.div`
	display: flex;
	flex-direction: column;
	${gap(20)};

	.input-wrapper {
		border: none;
		padding-left: 10px;
	}
`;

const Extension = styled.div`
	background-color: ${({ theme }) => theme.colors.primary};
	border-radius: 12px;
	padding: 5px 10px;
	color: ${({ theme }) => theme.colors.white};
`;
